import produce from "immer";

const initialState = { exams: {}, quiz: null, loading: true, error: false };
export function examStateReducer(state = initialState, action) {
  return produce(state, draft => {
    switch (action.type) {
      case "GET_EXAM_START":
        draft.loading = true;
        return;
      case "GET_EXAM_ERROR":
        draft.loading = false;
        draft.error = true;
        return;
      case "GET_EXAM_SUCCESS":
        draft.error = false;
        draft.exams = action.payload.reduce((prev, curr) => {
          prev[curr.examKey] = curr;
          return prev;
        }, {});
        return;
      case "GET_USER_QUIZ":
        draft.exams[action.payload.examKey].quiz = action.payload;
        return;
      case "EXAM_LOADING_COMPLETE":
        draft.loading = false;
        return;
      default:
        return state;
    }
  });
}
